import { render, staticRenderFns } from "./TheResourceList.vue?vue&type=template&id=71e26da0&"
import script from "./TheResourceList.vue?vue&type=script&lang=js&"
export * from "./TheResourceList.vue?vue&type=script&lang=js&"
import style0 from "./TheResourceList.vue?vue&type=style&index=0&id=71e26da0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports